import SuperTokens from 'supertokens-auth-react';
import EmailPassword from 'supertokens-auth-react/recipe/emailpassword';
import EmailVerification from 'supertokens-auth-react/recipe/emailverification';
import Session from 'supertokens-auth-react/recipe/session';
import ThirdParty, { Google } from 'supertokens-auth-react/recipe/thirdparty';

import { identifyHubspotContact } from 'src/Services/Hubspot/tracking';

export const supertokensInit = () =>
  SuperTokens.init({
    appInfo: {
      apiDomain: import.meta.env.VITE_API_URL,
      websiteDomain: import.meta.env.VITE_PUBLIC_URL,
      appName: 'shareheritage',
    },
    recipeList: [
      EmailVerification.init({ mode: 'REQUIRED' }),
      EmailPassword.init({
        onHandleEvent: context => {
          if (context.action === 'SUCCESS') {
            const user = context.user;

            identifyHubspotContact({ email: user.emails[0] });
          }
        },
        signInAndUpFeature: {
          signUpForm: {
            formFields: [
              {
                id: 'first_name',
                label: 'First name',
                placeholder: 'First name',
              },
              {
                id: 'last_name',
                label: 'Last name',
                placeholder: 'Last name',
              },
            ],
          },
        },
      }),
      ThirdParty.init({
        onHandleEvent: context => {
          if (context.action === 'SUCCESS') {
            const user = context.user;

            identifyHubspotContact({
              email: user.emails[0],
            });
          }
        },
        signInAndUpFeature: {
          providers: [Google.init()],
        },
      }),
      Session.init(),
    ],
  });
